import { ApolloError } from '@apollo/client'
import { GraphQLErrorWrapper } from './styles'
import { ExclamationCircleFilled } from '@ant-design/icons'
import popupError from 'globals/popupError'

export interface ErrorMessage {
  message: string
}

interface IProps {
  data?: any,
  apolloError?: ApolloError,
  displayTest?: boolean
}

export const popupGraphQLError = (data?: any, apolloError?: ApolloError) => {
  if (data && data.error) {
    popupError(data.error.message)
  } else if (apolloError && apolloError.graphQLErrors) {
    apolloError.graphQLErrors.forEach((error) =>
      popupError(error.message)
    )
  } else if (apolloError && apolloError.networkError) {
    popupError(apolloError.networkError.message)
  }
}

const GraphQLError = (props: IProps) => {
  const { data, apolloError, displayTest } = props

  if (data && data.error) {
    return <GraphQLErrorWrapper><ExclamationCircleFilled />{data.error.message}</GraphQLErrorWrapper>
  } else if (apolloError && apolloError.graphQLErrors) {
    return (
      <>
        {apolloError.graphQLErrors.map((error, id) =>
          <GraphQLErrorWrapper key={id}><ExclamationCircleFilled /> {error.message}</GraphQLErrorWrapper>
        )}
      </>
    )
  } else if (apolloError && apolloError.networkError) {
    return <GraphQLErrorWrapper><ExclamationCircleFilled /> {apolloError.networkError.message}</GraphQLErrorWrapper>
  } else if (displayTest) {
    return <GraphQLErrorWrapper><ExclamationCircleFilled /> Test error</GraphQLErrorWrapper>
  } else {
    return <></>
  }
}

export default GraphQLError
